import { TamaguiElement, XStack, XStackProps } from '@mythical/ui'
import { forwardRef } from 'react'
import { SolitoImage } from 'solito/image'

const logo = require('app/assets/svg/logo--full.svg')
const logoSmall = require('app/assets/svg/logo.svg')
const logoPink = require('app/assets/svg/logo-pink.svg')

type LogoProps = object & XStackProps

export const Logo = forwardRef<TamaguiElement, LogoProps>(
  ({ ...props }, ref) => {
    return (
      <XStack ref={ref} ai="center" fd="row" {...props}>
        <SolitoImage
          width={175}
          height={28}
          src={logo}
          alt="Mythical Society Logo"
        />
      </XStack>
    )
  },
)

export const LogoSmall = forwardRef<TamaguiElement, LogoProps>(
  ({ ...props }, ref) => {
    return (
      <XStack ref={ref} ai="center" fd="row" {...props}>
        <SolitoImage
          width={38}
          height={38}
          src={logoSmall}
          alt="Mythical Society Logo"
        />
      </XStack>
    )
  },
)

export const LogoPink = forwardRef<HTMLDivElement, LogoProps>(
  ({ ...props }, ref) => {
    return (
      <XStack w={175} h={28} $gtMd={{ w: 334, h: 53 }} ref={ref} {...props}>
        <SolitoImage
          alt="Mythical Society Logo"
          contentFit="contain"
          fill
          src={logoPink}
        />
      </XStack>
    )
  },
)
